import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Dialog from 'client/components/aria/Dialog/Dialog';
import Alert from 'client/components/ui/Alert/Alert';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';

import styles from './DeleteDialog.module.scss';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const DeleteDialog = ({
    isOpen,
    setIsOpen,
    title,
    onDelete,
    ...props
}) => {
    const intl = useIntl();
    const handleClose = () => setIsOpen(false);

    const handleDelete = () => {
        onDelete();
        handleClose();
    };

    return (
        <Dialog
            isOpen={isOpen}
            onClose={handleClose}
            isDismissable
            role={'alertdialog'}
            aria-labelledby={'delete.dialog.title'}
            data-testid = {props['data-testid'] ? props['data-testid'] : null}
            {...props}
        >
            <Alert role="document">
                <h2 className={[styles.title, 'govuk-error-summary__title'].join(' ')} id="delete.dialog.title">
                    {intl.formatMessage({ id: 'dialog.delete' }) + ' ' + title}
                </h2>
                <span className="govuk-caption-m govuk-!-text-align-centre">
                    {intl.formatMessage({ id: 'dialog.areYouSure' })}
                </span>
                <ButtonGroup className={styles.actionRow}>
                    <Button
                        onPress={handleClose}
                        variant="error"
                        data-testid = {props['data-testid'] ? props['data-testid'] + '-cancel' : null}
                    >
                        {intl.formatMessage({ id: 'general.cancel' })}
                    </Button>
                    <Button
                        onPress={handleDelete}
                        data-testid = {props['data-testid'] ? props['data-testid'] + '-confirm' : null}
                    >
                        {intl.formatMessage({ id: 'delete' })}
                    </Button>
                </ButtonGroup>
            </Alert>
        </Dialog>
    );
};

DeleteDialog.propTypes = {
    ...defaultAriaProps,
    title: PropTypes.string,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    onDelete: PropTypes.func.isRequired
};

DeleteDialog.defaultProps = {
    isOpen: false,
    setIsOpen: () => null
};
export default DeleteDialog;
